import { createMichelinThemeOptions } from "./createMichelinThemeOptions";

const michelinLightThemeOptions = createMichelinThemeOptions('light');

export {
  michelinLightThemeOptions,
};